import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["draggable", "dropzone"]

  dragstart(event) {
    event.dataTransfer.setData(
      "text/friendship-id",
      event.currentTarget.dataset.friendshipId,
    )
    event.dataTransfer.effectAllowed = "copy"
    event.currentTarget.classList.add("opacity-50")
  }

  dragend(event) {
    event.currentTarget.classList.remove("opacity-50")
  }

  dragover(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = "copy"
    event.currentTarget.dataset.dragover = "true"
  }

  dragleave(event) {
    // Only clear if we're truly leaving the dropzone, not just crossing a
    // child boundary (HTML drag events fire dragleave on parent when entering
    // a child).
    if (
      event.relatedTarget &&
      event.currentTarget.contains(event.relatedTarget)
    )
      return
    delete event.currentTarget.dataset.dragover
  }

  async drop(event) {
    event.preventDefault()
    delete event.currentTarget.dataset.dragover

    const friendshipId = event.dataTransfer.getData("text/friendship-id")
    const url = event.currentTarget.dataset.friendDragUrl
    if (!friendshipId || !url) return

    const token = document.querySelector('meta[name="csrf-token"]').content
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-CSRF-Token": token,
        Accept: "text/vnd.turbo-stream.html, text/html",
      },
      body: `friendship_id=${friendshipId}`,
    })

    if (response.redirected) {
      Turbo.visit(response.url)
    }
  }
}
